import React, { useState, useEffect } from "react";

// 导入词书封面图片 - 1 文件夹在 src 目录下
import zhuanSiCover from "../../1/专四.png";
import aroundWorldCover from "../../1/八十天环游地球.png";
import baseCover from "../../1/基础法语词库.png";
import littlePrinceCover from "../../1/小王子.png";
import numberDateCover from "../../1/数字与时间.png";
import foodCover from "../../1/法语餐饮常用词.png";

// 词书封面映射
const COVER_MAP = {
  "zhuan-si": zhuanSiCover,
  "around-world": aroundWorldCover,
  "base": baseCover,
  "little-prince": littlePrinceCover,
  "number-date": numberDateCover,
  "food": foodCover,
};

const DEFAULT_COVER = baseCover;

/**
 * 词书 3D 重叠轮播组件
 * 用于主页中间区域，类似图中的精美效果
 */
export default function BookSwitcher({ books = [], currentBook, onSwitchBook }) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isTransitioning, setIsTransitioning] = useState(false);

  // 当 currentBook 变化时，同步 currentIndex
  useEffect(() => {
    if (!currentBook || books.length === 0) return;
    const index = books.findIndex(book => book.id === currentBook.id);
    if (index !== -1 && index !== currentIndex) {
      setCurrentIndex(index);
    }
  }, [currentBook?.id, books]);

  // 防止空列表
  if (!books || books.length === 0) return null;

  const total = books.length;

  // 🔥 3D 重叠位置计算（优化版本）
  const getCardStyle = (index) => {
    const diff = index - currentIndex;
    const normalizedDiff = ((diff % total) + total) % total;
    const offset = normalizedDiff > total / 2 ? normalizedDiff - total : normalizedDiff;

    // 🔥 优化：更平滑的缩放和位移
    const scale = 1 - Math.abs(offset) * 0.12;
    const translateX = offset * 140;
    const translateY = Math.abs(offset) * 10;  // 轻微上下偏移
    const zIndex = 100 - Math.abs(offset) * 15;
    const opacity = 1 - Math.abs(offset) * 0.2;

    return {
      position: "absolute",
      left: "50%",
      top: "50%",
      transform: `translate(-50%, -50%) translateX(${translateX}px) translateY(${translateY}px) scale(${scale})`,
      zIndex,
      opacity,
      width: "220px",   // 🔥 增加宽度
      height: "320px",  // 🔥 增加高度，保持竖向比例
      borderRadius: "20px",
      overflow: "hidden",
      cursor: "pointer",
      transition: "all 0.6s cubic-bezier(0.4, 0, 0.2, 1)",
      boxShadow: Math.abs(offset) === 0 
        ? "0 25px 80px rgba(0, 0, 0, 0.5), 0 0 50px rgba(102, 126, 234, 0.3)"
        : "0 15px 40px rgba(0, 0, 0, 0.3)",
    };
  };

  // 左右切换
  const handlePrev = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prev) => (prev - 1 + total) % total);
    setTimeout(() => setIsTransitioning(false), 600);
  };

  const handleNext = () => {
    if (isTransitioning) return;
    setIsTransitioning(true);
    setCurrentIndex((prev) => (prev + 1) % total);
    setTimeout(() => setIsTransitioning(false), 600);
  };

  // 点击卡片切换
  const handleCardClick = (index) => {
    if (index === currentIndex) return;
    setIsTransitioning(true);
    setCurrentIndex(index);
    setTimeout(() => {
      onSwitchBook?.(books[index]);
      setIsTransitioning(false);
    }, 600);
  };

  return (
    <div style={{
      position: "absolute",
      top: "38%",           // 🔥 再向上移动（从 40% 改为 38%）
      left: "45%",          // 🔥 向右移动（从 44% 改为 46%）
      transform: "translate(-50%, -50%)",
      width: "800px",
      height: "360px",
      zIndex: 50,
    }}>
      {/* 左箭头 */}
      <button
        onClick={handlePrev}
        style={{
          position: "absolute",
          left: "50px",     // 🔥 调整左箭头位置（从 -80px 改为 -70px）
          top: "50%",
          transform: "translateY(-50%)",
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.25)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          border: "2px solid rgba(255, 255, 255, 0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "32px",
          color: "#fff",
          cursor: "pointer",
          zIndex: 1000,
          transition: "all 0.3s ease",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "rgba(255, 255, 255, 0.45)";
          e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "rgba(255, 255, 255, 0.25)";
          e.currentTarget.style.transform = "translateY(-50%) scale(1)";
        }}
      >
        ‹
      </button>

      {/* 右箭头 */}
      <button
        onClick={handleNext}
        style={{
          position: "absolute",
          right: "-70px",    // 🔥 右箭头位置保持一致（从 -80px 改为 -70px）
          top: "50%",
          transform: "translateY(-50%)",
          width: "56px",
          height: "56px",
          borderRadius: "50%",
          background: "rgba(255, 255, 255, 0.25)",
          backdropFilter: "blur(12px)",
          WebkitBackdropFilter: "blur(12px)",
          border: "2px solid rgba(255, 255, 255, 0.4)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          fontSize: "32px",
          color: "#fff",
          cursor: "pointer",
          zIndex: 1000,
          transition: "all 0.3s ease",
          boxShadow: "0 4px 20px rgba(0, 0, 0, 0.2)",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = "rgba(255, 255, 255, 0.45)";
          e.currentTarget.style.transform = "translateY(-50%) scale(1.1)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = "rgba(255, 255, 255, 0.25)";
          e.currentTarget.style.transform = "translateY(-50%) scale(1)";
        }}
      >
        ›
      </button>

      {/* 3D 重叠卡片容器 */}
      <div style={{
        position: "relative",
        width: "100%",
        height: "100%",
      }}>
        {books.map((book, index) => {
          const coverImage = COVER_MAP[book.id] || DEFAULT_COVER;
          const isActive = index === currentIndex;
          const cardStyle = getCardStyle(index);

          return (
            <div
              key={book.id}
              onClick={() => handleCardClick(index)}
              style={{
                ...cardStyle,
                border: isActive ? "3px solid rgba(102, 126, 234, 0.9)" : "2px solid rgba(255, 255, 255, 0.2)",
              }}
            >
              {/* 🔥 图片容器 */}
              <div style={{
                width: "100%",
                height: "calc(100% - 48px)",
                overflow: "hidden",
                background: "#fff",
              }}>
                <img 
                  src={coverImage} 
                  alt={book.name}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",      // 🔥 改为 cover 填满容器
                    objectPosition: "center center",
                  }}
                />
              </div>

              {/*  卡片底部文字区域 */}
              <div style={{
                position: "absolute",
                bottom: 0,
                left: 0,
                right: 0,
                height: "48px",
                background: isActive 
                  ? "linear-gradient(135deg, rgba(102, 126, 234, 0.95), rgba(118, 75, 162, 0.95))"
                  : "rgba(0, 0, 0, 0.7)",
                backdropFilter: "blur(10px)",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                padding: "0 12px",
              }}>
                <div style={{
                  color: "#fff",
                  fontSize: "16px",
                  fontWeight: 700,
                  textAlign: "center",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  textShadow: "0 2px 4px rgba(0,0,0,0.3)",
                  letterSpacing: "0.5px",
                }}>
                  {book.name}
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
